"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionStorage = exports.localStorage = exports.LocalStorage = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _memoryStorage = _interopRequireDefault(require("./memoryStorage.service"));

var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage() {
    var session = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$fallback = _ref.fallback,
        fallback = _ref$fallback === void 0 ? _memoryStorage["default"] : _ref$fallback;

    (0, _classCallCheck2["default"])(this, LocalStorage);
    (0, _defineProperty2["default"])(this, "storage", null);
    (0, _defineProperty2["default"])(this, "fallback", null);

    if (LocalStorage.isSupported) {
      this.storage = session ? window.sessionStorage : window.localStorage;
    } else {
      this.fallback = fallback;
    }
  }

  (0, _createClass2["default"])(LocalStorage, [{
    key: "getItem",
    value: function getItem(key) {
      var _this$fallback$getIte, _this$fallback, _this$storage;

      return (_this$fallback$getIte = (_this$fallback = this.fallback) === null || _this$fallback === void 0 ? void 0 : _this$fallback.getItem(key)) !== null && _this$fallback$getIte !== void 0 ? _this$fallback$getIte : ((_this$storage = this.storage) === null || _this$storage === void 0 ? void 0 : _this$storage.getItem(key)) || undefined;
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      var _this$fallback$setIte, _this$fallback2, _this$storage2;

      return (_this$fallback$setIte = (_this$fallback2 = this.fallback) === null || _this$fallback2 === void 0 ? void 0 : _this$fallback2.setItem(key, value)) !== null && _this$fallback$setIte !== void 0 ? _this$fallback$setIte : (_this$storage2 = this.storage) === null || _this$storage2 === void 0 ? void 0 : _this$storage2.setItem(key, value);
    }
  }, {
    key: "deleteItem",
    value: function deleteItem(key) {
      var _this$fallback$delete, _this$fallback3, _this$storage3;

      return (_this$fallback$delete = (_this$fallback3 = this.fallback) === null || _this$fallback3 === void 0 ? void 0 : _this$fallback3.deleteItem(key)) !== null && _this$fallback$delete !== void 0 ? _this$fallback$delete : (_this$storage3 = this.storage) === null || _this$storage3 === void 0 ? void 0 : _this$storage3.removeItem(key);
    }
  }], [{
    key: "isSupported",
    get: function get() {
      try {
        window.localStorage.getItem('');
        return true;
      } catch (_unused) {
        return false;
      }
    }
  }]);
  return LocalStorage;
}();

exports.LocalStorage = LocalStorage;
var localStorage = new LocalStorage();
exports.localStorage = localStorage;
var sessionStorage = new LocalStorage(true);
exports.sessionStorage = sessionStorage;